import React, { useState, useEffect } from "react";
import { getCustomer } from "../services/authenticatedRequests";
import MyAccountSideBar from "./MyAccountSideBar";
import { toast } from "react-toastify";
import EditProfileModal from "./EditProfileModal";
import ChangePasswordModal from "./ChangePassword";
import NoResultsComponent from "./NoResultsComponent";
import LoadingComponent from "./LoadingComponent";
const MyAccountPage = () => {
  document.title = "My Account | Bigmall";
  const [active, setActive] = useState(false);
  const [customer, setCustomer] = useState(null);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isChangePasswordModalOpen, setChangePasswordModalOpen] =
    useState(false);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Toggle the sidebar visibility
  const sidebarController = () => {
    //console.log("sidebarController");
    setActive(!active);
  };

  // Fetch customer details
  const fetchCustomer = async () => {
    setIsLoading(true);
    try {
      
      const response = await getCustomer();
      setCustomer(response);
      setIsError(false);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setIsError(true);
      console.error("Error fetching customer:", error.message);
    }
    finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomer();
  }, []);

  // Callback for when profile is updated successfully.
  // This callback receives the updated customer data from the modal.
  const handleEditProfileSave = (updatedCustomer) => {
    setCustomer(updatedCustomer);
    toast.success("Profile updated successfully.");
  };

  return (
    <section className="vendor-two-details py-20">
      <div
        className={`${active ? "show" : ""}`}
        onClick={sidebarController}
      ></div>
      <div className="container container-lg">
        <div className="vendor-two-details-wrapper d-flex flex-wrap align-items-start gap-24">
          <MyAccountSideBar
            active={active}
            sidebarController={sidebarController}
          />

          {/* Main Content */}
          <div className="vendor-two-details__contents flex-grow-1">
            <div className="bg-white rounded-8 p-24">
              <div className="d-flex justify-content-between align-items-center mb-24">
                <h4 className="mb-0">Account Information</h4>
                <button
                  onClick={sidebarController}
                  type="button"
                  className="shop-sidebar__toggle d-lg-none d-flex w-40 h-40 flex-center border border-gray-200 rounded-circle hover-bg-gray-50"
                >
                  <i className="ph ph-list" />
                </button>
              </div>
              

              {/* Account Information */}
              <div className="d-flex flex-column gap-16">
              {isLoading ? (
                <LoadingComponent message="Loading account information..." />
              ) : isError ? (
                <NoResultsComponent message="No account information available." />
              ) : (
                <>
                  <div className="d-flex justify-content-between border-bottom pb-8">
                    <span className="text-gray-500">First Name</span>
                    <span className="fw-medium">{customer.firstName}</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-8">
                    <span className="text-gray-500">Last Name</span>
                    <span className="fw-medium">{customer.lastName}</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-8">
                    <span className="text-gray-500">Username</span>
                    <span className="fw-medium">{customer.userName}</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-8">
                    <span className="text-gray-500">Display Name</span>
                    <span className="fw-medium">{customer.displayName}</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-8">
                    <span className="text-gray-500">Email</span>
                    <span className="fw-medium">{customer.email}</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-8">
                    <span className="text-gray-500">Phone Number</span>
                    <span className="fw-medium">{customer.phoneNumber}</span>
                  </div>
                </>
              )}
              </div>
           

              {customer && !isError && (
              <div className="d-flex gap-16 mt-24">
                <button
                  onClick={() => setEditModalOpen(true)}
                  className="text-main-600 hover-text-main-700 transition-2 d-flex align-items-center gap-8 btn btn-link p-0"
                >
                  <i className="ph ph-pencil-simple-line"></i>
                  Edit Profile
                </button>
                <button
                  onClick={() => setChangePasswordModalOpen(true)}
                  className="text-main-600 hover-text-main-700 transition-2 d-flex align-items-center gap-8 btn btn-link p-0"
                >
                  <i className="ph ph-lock-key"></i>
                  Change Password
                </button>
              </div>
              )}

              {/* Modals */}
              <EditProfileModal
                isOpen={isEditModalOpen}
                onClose={() => setEditModalOpen(false)}
                customer={customer}
                onSave={handleEditProfileSave}
              />
              <ChangePasswordModal
                isOpen={isChangePasswordModalOpen}
                onClose={() => setChangePasswordModalOpen(false)}
                email={customer?.email}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyAccountPage;
